import { Box, Typography, Button, Snackbar, Alert } from '@mui/material'
import { ContentCopy } from '@mui/icons-material'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import FilterHeader from '../components/scaffoldOrders/FilterHeader'
import { ScaffoldFilters } from '../types/Scaffold/Scaffold'	
import ScaffoldOrderList from '../components/scaffoldOrders/ScaffoldOrderList'
import { useTokenClaims } from '../security/useTokenClaims'
import NewRequestDialog from '../components/scaffoldOrders/NewRequestDialog'
import { usePermissionContext } from '../security/PermissionContext'

export default function ScaffoldManagementPage() {
	const location = useLocation()
	const [showCopySuccess, setShowCopySuccess] = useState(false)
	const { hasPermission } = usePermissionContext()
	const {
		fromNotification,
		scaffoldRequestId: fromNotificationScaffoldRequestId,
		key,
		assigneeId,
	} = (location.state as {
		scaffoldRequestId: string
		fromNotification: boolean
		searchWi: string
		key: number
		assigneeId?: number
	}) || {}
	const [filters, setFilters] = React.useState<ScaffoldFilters>({
		scaffoldRequestId: null,
		status: null,
		tagNumber: null,
		page: 0,
		requestedOn: null,
		action: null,
		priority: null,
		requiredBefore: null,
	})

	// Update filters when notification data is available
	React.useEffect(() => {
		if (fromNotificationScaffoldRequestId) {
			setFilters((prev) => ({
				...prev,
				scaffoldRequestId: parseInt(fromNotificationScaffoldRequestId),
			}))
		}
	}, [fromNotificationScaffoldRequestId])

	const handleCopyLink = async () => {
		try {
			await navigator.clipboard.writeText(
				`${window.location.origin}/request/${useTokenClaims().projectId}`,
			)
			setShowCopySuccess(true)
		} catch (error) {
			console.error('Failed to copy link:', error)
			// Could add user notification here if needed
		}
	}

	const handleCloseSnackbar = () => {
		setShowCopySuccess(false)
	}

	const handleRefreshScaffolds = () => {
		// Reset filters to trigger a refresh of the scaffold list
		setFilters((prev) => ({
			...prev,
			page: 0,
		}))
	}

	return (
		<div className='page-layout'>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					paddingLeft: '1rem',
					paddingRight: '1rem',
					paddingTop: '.5rem',
					zIndex: '3',
					width: '100%',
				}}
			>
				<Typography
					sx={{
						fontSize: '1.5rem',
					}}
				>
					Scaffold Orders
				</Typography>

				{!assigneeId && (
					<Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
						{hasPermission(78) && <NewRequestDialog onSuccess={handleRefreshScaffolds} />}
						{hasPermission(80) && <Button
							variant='outlined'
							startIcon={<ContentCopy />}
							onClick={handleCopyLink}
							sx={{
								minWidth: '200px',
								height: '40px',
								color: 'text.primary',
								'&:hover': {
									color: 'text.primary',
								},
							}}
						>
							Copy Request Page Link
						</Button>}
					</Box>
				)}
			</Box>

			<Box
				sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2, mx: 2 }}
				key={key}
			>
				<FilterHeader filters={filters} setFilters={setFilters} />
				<ScaffoldOrderList filters={filters} setFilters={setFilters} assigneeId={assigneeId} />
			</Box>

			<Snackbar
				open={showCopySuccess}
				autoHideDuration={3000}
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert onClose={handleCloseSnackbar} severity='success' sx={{ width: '100%' }}>
					Page link copied to clipboard!
				</Alert>
			</Snackbar>
		</div>
	)
}
